<router-outlet></router-outlet>
@for (pageSchema of (seoData | async)?.pageSchemas; track pageSchema) {
    <app-json-ld [json]="pageSchema.schema"></app-json-ld>
}
